/**
 * Descriptive public URLs for car pages.
 * Canonical: /car/01A123BC/<mongoId>
 * Legacy:    /car/<mongoId>  (still works, redirects to canonical)
 */

export function normalizePlateSlug(plate) {
  return String(plate || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

export function isMongoObjectId(value) {
  return /^[a-fA-F0-9]{24}$/.test(String(value || ''));
}

/** Path for React Router / internal links */
export function carPath(carOrPlate, maybeId) {
  let plate;
  let id;
  if (carOrPlate && typeof carOrPlate === 'object') {
    plate = carOrPlate.licensePlate;
    id = carOrPlate._id || carOrPlate.id;
  } else {
    plate = carOrPlate;
    id = maybeId;
  }
  const slug = normalizePlateSlug(plate);
  const idStr = String(id || '');
  if (!idStr) return '/';
  if (slug) return `/car/${encodeURIComponent(slug)}/${idStr}`;
  return `/car/${idStr}`;
}

/** Absolute URL for Telegram / sitemap / OG */
export function carPublicUrl(carOrPlate, maybeId, origin = 'https://avto-tarix.uz') {
  const path = carPath(carOrPlate, maybeId);
  return `${String(origin).replace(/\/$/, '')}${path}`;
}
